import { FeesForAmount } from '../../Wallet/FeesForAmount';
import { FeesForAmountSkeleton } from '../../Wallet/FeesForAmountSkeleton';
import { getAppConfig } from '@bts-web/core-app-config';
import { useClientLocale, useClientTranslation } from '@bts-web/utils-lokalise';

interface WithdrawalFeesBreakdownProps {
  amount: string;
  fee: string;
  isLoading?: boolean;
}

export const WithdrawalFeesBreakdown = ({
  amount,
  fee,
  isLoading = false,
}: WithdrawalFeesBreakdownProps) => {
  const { t } = useClientTranslation();

  const { currency } = getAppConfig();

  const locale = useClientLocale();

  const parsedAmount = Number(amount);

  const parsedFee = Number(fee);

  if (isLoading) return <FeesForAmountSkeleton />;

  return (
    <FeesForAmount
      amountLabel={t('tx_details_type_withdrawal')}
      feeLabel={t('fees')}
      totalLabel={t('total')}
      amount={Math.max(0, parsedAmount - parsedFee)}
      fee={parsedFee}
      total={parsedAmount}
      currency={currency}
      locale={locale}
    />
  );
};
